/*
    Generated using Simple-Scaffold
    npx simple-scaffold@latest \
        -t templates/feature -o src/features RunDetails

    TODO: Add the following lines in src/app/store.js:
    import runDetailsListenerCreators from '../features/runDetails/runDetailsListeners';
    runDetailsListenerCreators.forEach(listener => listener(listenerMiddleware));
*/

import {
    init as initAction,
    fetchDetailsAsync,
} from './runDetailsSlice';

const createInitListener = (listenerMiddleware) => {
    listenerMiddleware.startListening({
        actionCreator: initAction,
        effect: async (action, listenerApi) => {
            listenerApi.dispatch(fetchDetailsAsync(action.payload));
        },
    });
}

const listeners = [
    createInitListener,
]

export default listeners;